"use client";

import Link from "next/link";
import Image from "next/image";
import { useTranslation } from "react-i18next";
import WhatsAppIcon from "@/components/WhatsAppIcon";
import FAQSection from "@/components/sections/FAQSection";
import { routes } from "@/lib/routes";

const WHATSAPP_TOURNAMENTS = "https://wa.me/5492944636295?text=Hola%20Big%20Sports!%20Quiero%20anotar%20a%20mi%20equipo%20al%20torneo.%20Equipo:%20__%20Categoría:%20__%20Contacto:%20__%20Gracias!";

export default function TournamentsPage() {
  const { t } = useTranslation();

  return (
    <div className="bg-background">
      {/* Hero Banner */}
      <section className="relative flex min-h-[260px] flex-col items-center justify-center overflow-hidden px-4 sm:min-h-[300px] md:min-h-[320px]">
        <Image
          src="/new/DSC_3234-2.jpg"
          alt={t("images.tournamentsHero")}
          fill
          priority
          sizes="100vw"
          className="object-cover object-center"
          quality={80}
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(to bottom, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.6) 100%)",
          }}
          aria-hidden
        />
        <div className="relative z-10 text-center">
          <h1 className="text-2xl font-black tracking-tight text-white drop-shadow-lg sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl">
            {t("header.tournaments")} — {t("common.venueName")}
          </h1>
          <nav className="mt-4 flex items-center justify-center gap-2 text-sm font-medium text-white/90">
            <Link href={routes.home} className="transition hover:text-white">
              {t("contact.breadcrumbHome")}
            </Link>
            <span className="text-white/75" aria-hidden>–</span>
            <span className="text-white">{t("header.tournaments")}</span>
          </nav>
          <p className="mt-4 max-w-2xl text-base text-white/90 sm:text-lg">
            {t("chooseCards.card3Desc")}
          </p>
        </div>
      </section>

      <section className="bg-slate-50 py-16 sm:py-24">
        <div className="mx-auto w-full max-w-6xl px-4 sm:px-6">
          <div className="overflow-hidden rounded-3xl bg-white shadow-lg ring-1 ring-slate-200/50">
            <div className="p-8 sm:p-10 md:p-12">
              <h2 className="text-2xl font-bold text-slate-900 sm:text-3xl">
                {t("tournaments.calendar")}
              </h2>
              <p className="mt-4 text-slate-600 leading-relaxed max-w-2xl">
                {t("faq.a5")}
              </p>
              <a
                href={WHATSAPP_TOURNAMENTS}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-8 inline-flex items-center justify-center gap-2.5 rounded-xl bg-emerald-500 px-8 py-4 text-base font-bold text-white shadow-lg transition hover:bg-emerald-600 active:scale-[0.98]"
              >
                <WhatsAppIcon size={20} className="h-5 w-5" />
                {t("chooseCards.card3Cta")}
              </a>
            </div>
          </div>
        </div>
      </section>

      <FAQSection />
    </div>
  );
}
